(function () {
  'use strict';
  var key = 'rit-brand-visit-shared-v1';
  var page = window.ritBrandPage || {};
  var card = document.getElementById('rit-brand-discovery');
  var state, elapsed = 0, last = Date.now(), counted = false, cartEmpty = false;
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed() && Shopify.customerPrivacy.marketingAllowed());
  }
  function read() {
    if (!allowed()) return null;
    try {
      var saved = JSON.parse(localStorage.getItem(key) || sessionStorage.getItem('rit-brand-visit-v1') || 'null');
      if (!saved || Date.now() - saved.active > 1800000) saved = {active:Date.now(),views:[],added:false,shown:false};
      if (!Array.isArray(saved.views)) {
        saved.views = Object.values(saved.views || {}).reduce(function(all, views) {
          views.forEach(function(id) { if (all.indexOf(id) === -1) all.push(id); });
          return all;
        }, []);
        delete saved.context;
      }
      return saved;
    } catch (_) { return null; }
  }
  function save() {
    if (!state || !allowed()) return;
    state.active = Date.now();
    try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  }
  function withVisitLock(callback) {
    if (window.navigator.locks) return window.navigator.locks.request(key,callback);
    return Promise.resolve().then(callback);
  }
  function hideCard() { if (card) { card.close(); card.hidden = true; } }
  function added() { hideCard(); return withVisitLock(function(){state = read(); if (state) { state.added = true; save(); }}); }
  window.addEventListener('storage',function(event){
    if (event.key !== key || !allowed()) return;
    var shared = read();
    if (shared && shared.added) hideCard();
  });
  function checkCart() {
    return fetch((window.Shopify.routes.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'})
      .then(function(r){if(!r.ok) throw Error('cart'); return r.json();})
      .then(function(cart){cartEmpty = cart.item_count === 0; if (!cartEmpty) added(); return cartEmpty;})
      .catch(function(){cartEmpty = false; return false;});
  }
  // Observe successful adds from both the theme's jQuery AJAX and fetch-based add-ons.
  if (window.jQuery) jQuery(document).ajaxSuccess(function(_, xhr, options) {
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(options.url) && xhr.status < 400) added();
  });
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    return originalFetch.apply(this,args).then(function(response){
      if (response.ok && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url || '')) added();
      return response;
    });
  };
  document.addEventListener('cart:refresh',checkCart);
  document.addEventListener('visitorConsentCollected',function(){state = read(); elapsed = 0; last = Date.now(); if(!allowed()) hideCard();});
  if (card) {
    card.querySelector('.rit-brand-close').addEventListener('click',hideCard);
    card.addEventListener('close',function(){card.hidden=true;});
  }
  function start() {
    withVisitLock(function(){state = read(); if (state && page.product) save();});
    checkCart();
    setInterval(function(){
      var now = Date.now(), delta = now - last; last = now;
      if (!allowed() || document.hidden || !page.product || counted) return;
      elapsed += Math.min(delta,1000);
      if (elapsed < 6000) return;
      counted = true;
      withVisitLock(function(){
        state = read(); if (!state) return;
        var views = state.views;
        if (views.indexOf(page.product) === -1) views.push(page.product);
        save();
        if (views.length < 5 || state.added || state.shown || !cartEmpty) return;
        return checkCart().then(function(empty){
          state = read();
          if (!empty || !state || state.added || state.shown || !allowed()) return;
          if (!card || document.hidden) return;
          card.hidden=false; card.showModal();
          state.shown = true; save();
        });
      });
    },250);
  }
  if (window.Shopify && Shopify.customerPrivacy) start();
  else if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error) start();});
})();
